import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import http from "../service/http";
import en from "./en.json";
import hi from "./hi.json";
import id from "./id.json";
import ja from "./ja.json";
import ko from "./ko.json";
// import ms from "./ms.json";
import ph from "./ph.json";
import th from "./th.json";
// import vi from "./vi.json";
import zh from "./zh.json";
import zhHK from "./zh-HK.json";


// 获取语言环境
let { lang = "en" } = http.getQuery();

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    hi: { translation: hi },
    id: { translation: id },
    ja: { translation: ja },
    ko: { translation: ko },
    // ms: { translation: ms },
    ph: { translation: ph },
    th: { translation: th },
    // vi: { translation: vi },
    zh: { translation: zh },
    "zh-HK": { translation: zhHK },
  },
  lng: lang,
  fallbackLng: "en",
});

export default i18n;
